<template>
<main id="main" role="main" class="main">
    <h1 class="title is-marginless tactically-hidden is-1" v-if="ShowTacticalHeading">{{site_data.title}}</h1>
    <template v-if="site_data.blocks && site_data.blocks.length > 0" v-for="block, i in site_data.blocks">
        <component :is="block.type" :block="block" />
    </template>
    <WhitepaperForm />
</main>
</template>

<script>
import WhitepaperForm from '../blocks/WhitepaperForm';
import * as components from '../blocks/modules'
export default {
    name        :   'Page',
    props       :   ['site_data'],
    components  :   {WhitepaperForm, ...components},
    computed    :   {
        ShowTacticalHeading() {
            return this.$route.name != 'Homepage' &&
                this.site_data.pagetype != 'VideoPage' &&
                this.site_data.pagetype != 'SearchPage'
        }
    },
    mounted()
    {
        this.recalc();
        this.$bus.$on('onWindowScroll', this.recalc);
        window.addEventListener('resize', this.recalc);
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowScroll', this.recalc);
        window.removeEventListener('resize', this.recalc);
    },
    methods: {
        recalc()
        {
            const section = document.querySelector('section');
            const heroBodys = section.querySelectorAll('.hero-body');
            let top_margin = document.querySelector(".navbar-brand").clientHeight;
            if (heroBodys.length > 0) {
                heroBodys.forEach(heroBody => {
                    heroBody.style.marginTop = top_margin + 'px';
                });
            } else {
                section.style.marginTop = top_margin + 'px';
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Page.vue